@if ((showAvatarOnly)) {
    <lib-menu-button
        [kind]="kind"
        [size]="ButtonSize.Large"
        [iconOnly]="true"
        [hasCaretSuffix]="false"
        [prefixIcon]="null">
        <lib-profile-image
            profile
            [size]="avatarSize"
            [displayItem]="displayItem"
            [hasImageToShow]="hasImage"
            [imageURL]="imageURL ?? ''"></lib-profile-image>
        @for (menuItem of menuItemComponents; track menuItem) {
            <lib-menu-item
                [label]="menuItem.label"
                [prefixIcon]="menuItem.prefixIcon"
                [prefixIconVisible]="menuItem.prefixIconVisible"
                [suffixIcon]="menuItem.suffixIcon"
                [suffixIconVisible]="menuItem.suffixIconVisible"
                [menuDivider]="menuItem.menuDivider"
                [disabled]="menuItem.disabled"
                (clicked)="menuItem.clicked.emit()"></lib-menu-item>
        }
    </lib-menu-button>
} @else {
    <div class="sb-avatar-button-container" data-clarity-mask="true">
        <lib-profile-image
            [size]="avatarSize"
            [displayItem]="displayItem"
            [hasImageToShow]="hasImage"
            [imageURL]="imageURL ?? ''"></lib-profile-image>
        <lib-menu-button
            [kind]="kind"
            [size]="ButtonSize.Large"
            [qaTag]="qaTag"
            (clicked)="ButtonClicked()">
            <ng-container label>{{ name }}</ng-container>
            @for (menuItem of menuItemComponents; track menuItem) {
                <lib-menu-item
                    [qaTag]="menuItem.qaTag ? menuItem.qaTag : ''"
                    [label]="menuItem.label"
                    [prefixIcon]="menuItem.prefixIcon"
                    [prefixIconVisible]="menuItem.prefixIconVisible"
                    [suffixIcon]="menuItem.suffixIcon"
                    [suffixIconVisible]="menuItem.suffixIconVisible"
                    [menuDivider]="menuItem.menuDivider"
                    [disabled]="menuItem.disabled"
                    (clicked)="menuItem.clicked.emit()"></lib-menu-item>
            }
        </lib-menu-button>
    </div>
}
